import { NameAttribute } from "../../attributes/name/component";
import { LabelAttribute } from "../../attributes/label/component";
import { ButtonTextAttribute } from "../../attributes/button-text/component";
import AttributePanelHeader from "../attribute-panel-header";
import { EntityKey } from "@/types/form-builder";
import Accordion from "@ui/accordion";
import VisibilityAttributes from "../../attributes/visibility-attributes";
import { SelectionOptionIcon } from "@/components/icons";
import { ModalDatasourceAttribute } from "../../attributes/modal-datasource/component";

export function ModalSelectionAttributes() {
  return (
    <>
      <AttributePanelHeader
        icon={<SelectionOptionIcon className="text-purple" />}
        componentType={EntityKey.modalSelection}
        className="bg-purple/10 border-purple"
      />
      <Accordion
        key={EntityKey.modalSelection}
        items={[
          {
            key: "general",
            name: "General",
            content: (
              <div className="flex flex-col gap-4">
                <NameAttribute />
                <LabelAttribute />
                <ButtonTextAttribute />
                <VisibilityAttributes type={EntityKey.modalSelection} />
              </div>
            ),
          },
          {
            key: "data-source",
            name: "Set Value Settings",
            content: <ModalDatasourceAttribute />,
          },
        ]}
      />
    </>
  );
}
